import React from "react"
import Button from "./button"
import { FormItem, isEqual } from "./OpenForms/OpenForms"
import { OpenForms, FormProps, Form } from "./OpenForms/OpenFormsWeb"
import { formGroup } from "./formGroup";

const Submit = (props: { children?: React.ReactNode, alwaysActive?: boolean, additionalClass?: string }) => <FormItem>
    {context => {
        const disabled = !props.alwaysActive && !context.dirty
        const className = `btn ${disabled ? "btn-outline-secondary" : "btn-primary"} ${props.additionalClass ?? ""}`;
        return <button
            type="submit"
            disabled={disabled}
            className={className}>
            {props.children ?? <><i className="fa fa-check" /> Salva</>}
        </button>
    }}
</FormItem >;

export const Divider: React.FunctionComponent<{
    caption: string | JSX.Element,
    color?: "theme" | "primary" | "success" | "warning" | "danger" | "secondary" | "info"
    additionalItems?: JSX.Element,
}> = ({ caption, color, additionalItems }) => {
    return (<div className="mb-3 row">
        <div className="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-2" style={{ maxWidth: 250 }}>
            <span className="fw-bold text-uppercase w-100" >
                {caption}
            </span>
            <div className={`bg-${color ?? "theme"}`} style={{ height: 3, borderRadius: 30 }}></div>
        </div>
        <div className="col-12 col-sm-6 col-md-9 col-lg-9 col-xl-10 d-flex justify-content-end align-items-center">
            {additionalItems}
        </div>
    </div>);
}

const Cancel = (props: { onCancel: () => void }) => <Button
    type="button"
    color="inverse"
    onClick={props.onCancel}
>
    <i className="fas fa-undo" /> Esci
</Button>

type CmFormProps<T> = FormProps<T> & {
    floatingLabels?: boolean;
};
const CmForm: <T>(props: CmFormProps<T>) => React.ReactElement | null = props => {
    const { floatingLabels, className, ...p } = props;
    return <Form
        {...p}
        className={
            floatingLabels
                ? (className ? `${className} floating-labels p-4` : "floating-labels p-4")
                : className
        }
    />
}

const ActionBar = (props: { onCancel?: () => void, className?: string, alwaysActive?: boolean, children?: React.ReactNode }) => <div className={"form-actions mb-3 " + props.className}>
    <Submit alwaysActive={props.alwaysActive} />
    {" "}
    {props.onCancel != null && <Cancel onCancel={props.onCancel} />}
    {props.children}
</div>

export function Forms<T>() {
    const forms = OpenForms<T>()
    return {
        FormContext: forms.Form,
        Form: CmForm as React.ComponentType<CmFormProps<T>>,
        FormItem: forms.FormItem,
        FormText: forms.FormText,
        FormTextArea: forms.FormTextArea,
        FormFloat: formGroup(forms.FormFloat),
        FormInteger: formGroup(forms.FormInteger),
        FormCheck: forms.FormCheck,
        FormSwitch: forms.FormSwitch,
        FormDate: forms.FormDate,
        FormDateTime: forms.FormDateTime,
        Cancel,
        Submit,
        ActionBar,
        isEqual
    }
}